// extracted by mini-css-extract-plugin
module.exports = {"SimilarVectors":"style-module--SimilarVectors--3Gj-H","seeMore":"style-module--seeMore--1TvgG","smallTitleCarrier":"style-module--smallTitleCarrier--2ofCr"};